import React, { useContext } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-awesome-modal';
import { useHistory } from 'react-router-dom';
import { createPollFb } from '../db';
import { useAuth0 } from "../helpers/react-auth0-spa";
import { IAppState } from '../db/reducers';
import NewPollDrawer from './NewPollDrawer';
import RemovePollDrawer from './RemovePollDrawer';
import styled, { ThemeContext } from 'styled-components';

const SModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
  height: 50vh;
  width: 60vw;
  background: ${(props) => props.theme.background};
  justify-content: flex-start;
`;

const SModalHeader = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 0;
  width: 60vw;
  height: 2vh;
`;

const SModalBody = styled.div`
  display: flex;
  justify-content: center;
  width: 60vw;
  height: 58vh;
`;

export enum DrawerType { 'CREATE', 'DELETE' }

interface IDrawer {
  isDrawerVisible: boolean;
  setDrawerVisible: (isVis: boolean) => unknown;
  type: DrawerType
  pollId?: string;
}

const Drawer: React.SFC<IDrawer> = (props) => {
  const themeContext = useContext(ThemeContext);

  const { isAuthenticated } = useAuth0();
  const history = useHistory();

  const { pollId, isDrawerVisible, setDrawerVisible, type } = props

  return (
    <>
      {!isAuthenticated && history.push('/')}
      <Modal
        visible={isDrawerVisible}
        effect='fadeInUp'
        className="NewPollModal"
      >
        <SModal className={"SModal"}>
          <SModalHeader className={"SModalHeader"}>
            <button style={{ border: 'none', backgroundColor: `${themeContext.background}` }} onClick={() => setDrawerVisible(false)}>
              x
            </button>
          </SModalHeader>
          <SModalBody className={"SModalBody"}>
            { type === DrawerType.CREATE && <NewPollDrawer setDrawerVisible={setDrawerVisible} /> }
            { type === DrawerType.DELETE && pollId && <RemovePollDrawer pollId={pollId} setDrawerVisible={setDrawerVisible} /> }
          </SModalBody>
        </SModal>
      </Modal>
    </>
  );
};

const mapStateToProps = (state: IAppState) => state;

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    createPoll: (currentPollId: string, currentPollOwner: string) => {
      createPollFb(currentPollId, currentPollOwner)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Drawer);
